<template>
    <div>
        <download-csv-button v-if="inspectionRequests.length !== 0" :context="downloadCsvContext"
            :modelName="'inspection-requests'" class="download-csv-button"></download-csv-button>
        <div class="request-table-search-container">
            <div class="search-label">Filtre de recherche</div>
            <el-input v-model="searchValue" placeholder="Chercher parmi les données du tableau"
                prefix-icon="el-icon-search"></el-input>
        </div>
        <el-table :data="filteredInspectionRequests" :row-class-name="tableRowClassName" style="width: 100%">
            <el-table-column label="Plaque" prop="plate">
            </el-table-column>
            <el-table-column label="Numéro de parc" prop="fleet_reference">
            </el-table-column>
            <el-table-column label="Date de la requête d'inspection">
                <template slot-scope="scope">
                    <span>
                        {{ scope.row.scheduled_date_start | moment('DD/MM/YYYY') }} - {{ scope.row.scheduled_date_end |
                            moment('DD/MM/YYYY') }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="Disponibilité">
                <template slot-scope="scope">
                    <span v-if="scope.row.vehicle_available">
                        Véhicule disponible
                    </span>
                    <span v-else-if="scope.row.vehicle_out_of_fleet">
                        Inspection refusée
                    </span>
                    <span v-else-if="scope.row.client_has_answered">
                        Inspection reprogrammée
                    </span>
                    <span v-else>En attente d'une réponse...</span>
                </template>
            </el-table-column>
            <el-table-column label="Dernière inspection">
                <template slot-scope="scope">
                    <div v-if="lastVehicleInspectionDate(scope.row)">{{ lastVehicleInspectionDate(scope.row) |
                        moment('DD/MM/YYYY') }}</div>
                    <div v-else>Aucune inspection</div>
                </template>
            </el-table-column>
            <el-table-column label="Actions" fixed="right" width="300">
                <template slot-scope="scope">
                    <operations :inspectionRequest="scope.row" :userIsClient="userIsClient"></operations>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import Operations from './operations.vue';
import DownloadCsvButton from '@/components/partials/download-csv-button.vue';
import { mapGetters } from 'vuex';

export default {

    components: {
        Operations,
        DownloadCsvButton,
    },

    props: {

        answered: {
            type: Boolean,
            required: true,
        },
        inspectionRequests: {
            type: Array,
            required: true
        },
        vehicles: {
            type: Array,
            required: true
        },

    },

    data() {
        return {
            searchValue: ''
        };
    },

    computed: {
        ...mapGetters([
            'getSelectedFleet',
        ]),
        filteredInspectionRequests() {
            if (this.searchValue !== '') {
                return this.inspectionRequests.filter(ir => {
                    return ir.plate.toLowerCase().includes(this.searchValue.toLowerCase()) || ir.fleet_reference.toLowerCase().includes(this.searchValue.toLowerCase());
                });
            }
            return this.inspectionRequests;
        },
        userIsClient() {
            return this.$store.getters.currentUser.is_client;
        },

        downloadCsvContext() {
            return {
                "client_has_answered": this.answered,
                "client_group": this.getSelectedFleet,
                "model": "Inspections"
            }
        },
        vehiclesByUid() {
            let indexed = {};
            for (let vehicle of this.vehicles) {
                indexed[vehicle.uid] = vehicle;
            }
            return indexed;
        }
    },

    methods: {
        lastVehicleInspectionDate(inspection) {
            let vehicle = this.vehiclesByUid[inspection.vehicle_uid];
            if (vehicle) {
                return vehicle.last_inspection_date;
            }
            return undefined;
        },
        tableRowClassName(row) {
            if (row.row.vehicle_out_of_fleet) {
                return 'archived-row';
            } else if (row.row.vehicle_available) {
                return 'confirmed-row';
            } else if (row.row.client_has_answered) {
                return 'reschedule-row';
            }
            return '';
        },
    },
};
</script>

<style lang="scss">
.requests-table {
    .archived-row {
        background-color: #d7d8da;
    }

    .confirmed-row {
        background-color: #c3e7b1;
    }

    .reschedule-row {
        background-color: #f6dfbc;
    }

}

.request-table-search-container {
    display: flex;
    align-items: center;
    padding: 15px;
    background-color: #f4f4f5;
    margin-bottom: 30px;

    .search-label {
        margin-right: 20px;
        width: 151px;
    }
}

.download-csv-button {
    margin-bottom: 10px;
    margin-left: 87%;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Home/requests-table.vue